export const getPercent = (part: number, whole: number) => {
  return Math.ceil((part / whole) * 100);
};
